export const getSelectInputChoices = items =>
  items ? items.map(item => ({ label: item.name, value: String(item.id) })) : [];
